<div class="gallery-widget">
    <div class="gallery-wrapper">
        <lightgallery [ngClass]="getWrapperClasses()" [settings]="settings">
            <a *ngFor="let image of widget.data.images" [href]="getSrcUrl(image)">
                <app-webp-image [src]="getThumbnailUrl(image)" [alt]="image.title" [title]="image.title"></app-webp-image>
            </a>
        </lightgallery>
    </div>
</div>
